import React, { Component } from 'react';
import { Link } from "react-router-dom";

import publicApi from "../../utils/publicApi";
import ProjectCard from "../shared/ProjectCard";
import Loading from './Loading';

/**
 * Section « Projets » de l'accueil.
 *
 * Calquée sur la section « Derniers Articles » (Work.js) : même `.work-area`,
 * même grille de `.single-work`, même bouton `.primary-btn`. Pas de carrousel,
 * pas de jQuery — la grille du thème fait le travail et gère déjà le mode
 * sombre. Cf. docs/STYLE_FRONT_LEGACY.md.
 */
export default class ProjectsShowcase extends Component {

    constructor(props) {
        super(props);

        this.state = {
            projects: [],
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        this.loadProjects();
    }

    loadProjects = async () => {
        try {
            this.setState({ loading: true, error: null });

            const response = await publicApi.get('/api/projects?featured=true&limit=6');

            this.setState({
                projects: response.data?.projects || [],
                loading: false,
            });
        } catch (error) {
            console.error("Error loading projects:", error);
            this.setState({
                projects: [],
                loading: false,
                error: "Impossible de charger les projets.",
            });
        }
    }

    render() {
        const { projects, loading, error } = this.state;

        // Pas de projet mis en avant : on n'affiche pas une section vide.
        if (!loading && !error && projects.length === 0) {
            return null;
        }

        return (
            <>
                {/* Start Projects Area */}
                <section className="work-area projects-area section-gap" id="projects">
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-6">
                                <div className="section-title">
                                    <h2>Mes Projets</h2>
                                    <p>
                                        Des projets menés de bout en bout — le contexte, les choix
                                        techniques, et ce qui a résisté.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {loading ? (
                                <div className="col-12">
                                    <Loading variant="dots" size="medium" color="primary" text="Chargement des projets..." />
                                </div>
                            ) : error ? (
                                <div className="col-12">
                                    <div className="text-center py-5">
                                        <p>{error}</p>
                                        <button
                                            type="button"
                                            className="primary-btn mt-3"
                                            data-text="Réessayer"
                                            onClick={this.loadProjects}
                                        >
                                            {"Réessayer".split("").map((rows, keys) => <span key={keys}>{rows}</span>)}
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                projects.map((project) => (
                                    <ProjectCard key={project.id} project={project} />
                                ))
                            )}
                        </div>

                        {!loading && !error && (
                            <div className="row">
                                <div className="col-12 text-center">
                                    <Link to="/projets" className="primary-btn">
                                        <span className="lnr lnr-arrow-right"></span>
                                        Voir tous les projets
                                    </Link>
                                </div>
                            </div>
                        )}

                    </div>
                </section>
                {/* End Projects Area */}
            </>
        );
    }
}
